import { Typography, Container, Box } from '@mui/material';
import { theme } from 'theme';


export const DiscoverSection = () => {
   return (
      <Box component={'section'} padding={"4rem 0"} >
         <Container>
            <Typography variant='h2' sx={{ marginBottom: "2rem", textAlign: "center" }}>
               Discover the E-SmartWash {' '}
               <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                  Revolution!
               </Box>
            </Typography>

            <Typography sx={{ marginBottom: "2rem", textAlign: "center" }}>
               Laundry is no longer boring! With E-Smartwash, it can be as productive as you want it to be. Our system is transforming how laundry is done; it is designed to suit today’s busy lifestyles. You can check machine availability, receive real-time updates about the status of your jobs, and make payments online with a click. And while you wait for your laundry to get done, feel free to use our Wi-Fi to catch up on pending work, enjoy a good book, or play your favourite online game.
            </Typography>


            <Typography textAlign={"center"} >
               E-Smartwash is truly a revolution that makes laundry enjoyable rather than a burdensome chore. We invite you to experience the difference today at our Hamilton laundromat!
            </Typography>
         </Container>
      </Box >
   );
}
